module.exports = __webpack_public_path__ + "static/media/guarantee-product-4.459dc4e8.png";